export default __webpack_public_path__ + "static/media/evanGelders.e9693d8c.svg";